export default [
  {
    path: "/login/",
    name: "Login",
    component: () => import("../components/Login.vue")
  },
  {
    path: "/register/",
    name: "Registration",
    component: () => import("../components/Registration.vue")
  },
  {
    path: "/usernamerecovery/",
    name: "UsernameRecovery",
    component: () => import("../components/UsernameRecovery.vue")
  },
  {
    path: "/passwordrecovery/",
    name: "PasswordRecovery",
    component: () => import("../components/PasswordRecovery.vue")
  }
];
